<template>
  <div class="modal fade" id="newFolderModal" tabindex="-1" role="dialog" aria-labelledby="newFolderModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Folder</h5>
        </div>
        <div class="modal-body">
          <div>
            <div class="form-group row align-items-center">
              <div class="col">
                <input v-model="name" placeholder="Folder Name" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" v-on:click="submit">Create Folder</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "api";

  export default {
    data() {
      return {
        name: '',
      };
    },
    methods: {
      submit: function() {
        if(this.name){

          var project_area = this.$store.state.project_areas.filter(area => {
            return area.file_cabinet === true
          })[0]

          api.createProject({ name: this.name, project_area_id: project_area.id, project_area_name: '' }).then(response => {
            this.name = '';
            $('#newFolderModal').modal('hide')
          });
        }
      },
    }
  }
</script>
